/**
 * Describes whether an existing generated discount code can be reused,
 * should be regenerated, or should block generation.
 */
export enum GeneratedDiscountCodeReuseStatus {
  Usable = "usable",
  Expired = "expired",
  NoGeneratedDiscountCode = "no_generated_discount_code",
  RecoverCodeAlreadyUsed = "recover_code_already_used",
}
